// src/index.tsx (or src/main.tsx) - UPDATED CONTENT

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Import all necessary providers
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@emotion/react';
import customeTheme from './Theme/customeTheme'; // Make sure this path is correct
import { ShopProvider } from './context/ShopContext'; // Make sure this path is correct
import { AuthProvider } from './context/AuthContext'; // Make sure this path is correct

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    {/* Wrap the entire application with necessary providers */}
    <Router>
      <ThemeProvider theme={customeTheme}>
        <ShopProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ShopProvider>
      </ThemeProvider>
    </Router>
  </React.StrictMode>
);